import { XIcon } from 'lucide-react';
import styles from './TextFieldClearButton.module.css';
import { useTranslation } from 'react-i18next';

interface TextFieldClearButtonProps {
  fieldName: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const TextFieldClearButton = ({ onClick, fieldName }: TextFieldClearButtonProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      aria-label={t('form.screenreader.clearField', {
        fieldName,
      })}
      onClick={onClick}
      className={styles.button}
    >
      <XIcon />
    </button>
  );
};
